<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">반려내용</th>
							<td class="col-11"><el-input v-model="input1" /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data: '',
			date1: '',
			input1: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	}
};
</script>

<style></style>
